import { createFileRoute, redirect } from "@tanstack/react-router";

/** 旧深链兼容：元数据模板已收敛到抽取模板列表 */
export const Route = createFileRoute("/_app/tenant-settings/metadata-templates/")({
  beforeLoad: () => {
    throw redirect({ to: "/data-center/tmpl", search: { kind: "metadata" } });
  },
});
